// A17.13 SLO / reliability dashboard — module-local data layer. READ-ONLY
// aggregate over incidents + background-job runs. No table of its own.
import { api } from '@/lib/api'

export interface ReliabilitySummary {
  incidents: {
    total: number
    open: number
    resolved: number
    mttr_minutes: number
    open_by_severity: Record<string, number>
  }
  jobs: {
    runs_7d: number
    errors_7d: number
    error_rate_pct: number
  }
}

export const fetchReliability = (s?: AbortSignal) =>
  api.get<ReliabilitySummary>('/admin/reliability/summary', s ? { signal: s } : undefined)

export const fetchAutoIncident = (s?: AbortSignal) =>
  api.get<{ enabled: boolean }>('/admin/reliability/auto-incident', s ? { signal: s } : undefined).then((d) => d.enabled)
export const setAutoIncident = (enabled: boolean) =>
  api.post<{ enabled: boolean }>('/admin/reliability/auto-incident', { enabled })

export const SEV_LABEL: Record<string, string> = {
  sev1: 'SEV1', sev2: 'SEV2', sev3: 'SEV3', sev4: 'SEV4',
}

export const RE_STR = {
  title: 'Надёжность / SLO',
  desc: 'Инциденты (MTTR) + частота ошибок фоновых задач (только чтение)',
  openIncidents: 'Открытые инциденты',
  mttr: 'MTTR (мин)',
  resolved: 'Решено',
  totalIncidents: 'Всего инцидентов',
  jobRuns: 'Запуски задач (7д)',
  jobErrors: 'Ошибки (7д)',
  errorRate: 'Частота ошибок',
  openBySev: 'Открытые по уровню',
  view: 'Открыть',
  autoIncident: 'Авто-инциденты',
  autoIncidentHint: 'Автоматически открывать инциденты при сигналах (break-glass, фрод, сбои задач)',
  done: 'Готово',
  failed: 'Ошибка',
} as const
